import React, { useContext, useEffect, useRef, useState } from "react";
import { RecadastramentoContext } from "@contexts";
import { Alert, Button, Col, Input, Row } from "@intech/web-ui";
import { FaAngleDoubleRight, FaCheck, FaTimes } from "react-icons/fa";
import { LoadingComponent } from "@components";

interface IProps {
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
}

export const Passo1: React.FC<IProps> = ({
  avancar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);

  const [MatriculaFuncional, setMatriculaFuncional] = useState<string>("");
  const [Nome, setNome] = useState<string>("");
  const [Checked, setChecked] = useState<boolean>(false);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        const dados = await context.buscarDadosOriginais();

        setMatriculaFuncional(dados.NUM_MATRICULA)
        setNome(dados.NOME_ENTID);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function handleAceitaTermos() {
    setChecked(!Checked);
  }

  async function handleAvancar() {
    avancar();
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          <Input
            value={MatriculaFuncional}
            title={"Matrícula Funcional"}
            readonly
          />

          <Input
            value={Nome}
            title={"Nome"}
            readonly
          />

          <Alert type={"info"}>{"Ao iniciar o recadastramento, em caso de alteração, tenha organizado e digitalizado seus documentos de comprovação, como, por exemplo, Identidade, CPF, Certidão de Casamento, entre outros."}</Alert>

          <Row className={"mb-2"}>
            <Col className={"col-lg-3 align-self-center"}>
              <Button
                className={"mb-2"}
                title={"Li e concordo com os termos abaixo."}
                type={Checked ? "success" : "danger"}
                icon={Checked ? <FaCheck /> : <FaTimes />}
                onClick={handleAceitaTermos}
              />
            </Col>

            <Col className={"align-self-center"}>
              <Alert type={"warning"}>
                {"Clique na mensagem ao lado para aceitar."}
              </Alert>
            </Col>
          </Row>

          <Alert type={"info"}>
            {"Em observância a Lei nº 13.709/2018, que dispõe sobre o tratamento de dados pessoais, concedo o direito de uso dos meus dados pessoais por mim fornecidos nesse momento, com o objetivo único e exclusivo de manutenção junto ao Plano de Benefício ao qual sou filiado, podendo ser fornecidos aos órgãos governamentais que os requererem."}
          </Alert>

          <Row>
            <Col children={<></>} />

            <Col>
              <Button
                type={"primary"}
                title={"Continuar"}
                icon={<FaAngleDoubleRight />}
                disabled={!Checked}
                onClick={handleAvancar}
                block
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
}